// extracted by mini-css-extract-plugin
export var category = "_kj-9";
export var categoryHeader = "_kj-e";
export var container = "_kj-0";
export var group = "_kj-a";
export var groupItems = "_kj-f";
export var groupSeparator = "_kj-j";
export var loading = "_kj-1";
export var noResults = "_kj-3";
export var placeholder = "_kj-2";
export var resultContent = "_kj-5";
export var resultIcon = "_kj-c";
export var resultItem = "_kj-g";
export var resultMeta = "_kj-8";
export var resultSubtitle = "_kj-7";
export var resultSuffix = "_kj-i";
export var resultTitle = "_kj-6";
export var resultsList = "_kj-4";
export var searchGroup = "_kj-d";
export var selected = "_kj-h";
export var subgroup = "_kj-b";